import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";

export default function OwnerDashboard() {
  const [hrs, setHrs] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/owner/hr"); setHrs(data); }
    catch { toast.error("Failed to load team"); }
  };
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/owner/hr", form);
      setForm({ name: "", email: "", password: "" });
      toast.success("HR sub-account created");
      load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); }
    finally { setLoading(false); }
  };

  const remove = async (uid) => {
    if (!confirm("Remove this HR member?")) return;
    try { await api.delete(`/owner/hr/${uid}`); load(); toast.success("Removed"); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <span className="text-xs uppercase tracking-[0.2em] text-[#D96C5B] font-semibold">Company</span>
      <h1 className="text-3xl font-bold tracking-tight mt-1">Your hiring team</h1>

      <form onSubmit={create} className="bg-white border border-[#E2E4E2] p-6 mt-6 grid grid-cols-1 md:grid-cols-4 gap-3" data-testid="owner-create-form">
        <Input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-none h-11" required data-testid="hr-name" />
        <Input type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="rounded-none h-11" required data-testid="hr-email" />
        <Input type="password" placeholder="Temp password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="rounded-none h-11" minLength={6} required data-testid="hr-password" />
        <Button type="submit" disabled={loading} className="rounded-none h-11 bg-[#1E3F33] hover:bg-[#152C24]" data-testid="hr-create">{loading ? "Adding…" : "Add HR"}</Button>
      </form>

      <div className="bg-white border border-[#E2E4E2] mt-6 divide-y divide-[#E2E4E2]" data-testid="owner-hr-list">
        {hrs.length === 0 && <div className="p-6 text-sm text-[#68706B]">No team members yet.</div>}
        {hrs.map((h) => (
          <div key={h.user_id} className="p-4 flex items-center justify-between">
            <div>
              <div className="font-semibold">{h.name}</div>
              <div className="text-xs text-[#68706B]">{h.email}</div>
            </div>
            <Button onClick={() => remove(h.user_id)} variant="outline" className="rounded-none" data-testid={`remove-hr-${h.user_id}`}><Trash2 className="w-4 h-4" /></Button>
          </div>
        ))}
      </div>
    </div>
  );
}
